<div class="barcode-wrapper" *ngIf="initProductsInCart">
  <div class="camera-fix-area">
    <div>
      <!-- <lib-scanner (outputCodeScanned)="onBarcodeScanned($event)"></lib-scanner> -->
      <ng-template
        [libCustomHostDynamic]="scannerComponent"
        [inputs]="{}"
        [outputs]="{ outputCodeScanned: onBarcodeScanned.bind(this) }"
      >
      </ng-template>
    </div>
    <div class="-ean text-center" *ngIf="notFound">
      <div class="not-found-close cursor-pointer">
        <i class="fas fa-times click-icon" (click)="notFound = false"></i>
      </div>
      <span translate>Cannot find barcode</span> {{ notFoundCode }}
    </div>
  </div>

  <div class="cart-list" [class.cart-full]="fullscreen">
    <!-- <lib-products-in-cart [allProducts]="products" [stockIds]="stockIds" [fullscreen]="fullscreen" *ngIf="initProductsInCart"></lib-products-in-cart> -->
    <ng-template
      [libCustomHostDynamic]="productsInCartComponent"
      [inputs]="{ allProducts: products, stockIds: stockIds, fullscreen: fullscreen }"
      [outputs]="{}"
    >
    </ng-template>
  </div>
</div>

<div *ngIf="!initProductsInCart" class="text-center">
  <i class="fa fa-spinner fa-spin fa-7x"></i>
</div>
